<!-- Start Content-->
<div class="container-fluid">
    <div class="row my-1">
        <div class="col-md-12">
            <div class="userTables">

                <!-- <div class="searchForm" *ngIf="!isModal">
                        <div class="row">
                            <div class="col-6">
                                <div class="input-group">
                                    <input type="date" name="" class="form-control">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text p-0 border-0">
                                            <input _ngcontent-yso-c7="" class="form-control" disabled="" maxlength="5" name="starttime" type="text">
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="input-group">
                                    <input type="date" name="" class="form-control">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text p-0 border-0">
                                            <input _ngcontent-yso-c7="" class="form-control" disabled="" maxlength="5" name="starttime" type="text">
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row mt-1">
                            <div class="col-md-3 col-6">
                                <select class="form-control">
                                    <option>select sports</option>
                                    <option>1</option>
                                    <option>2</option>
                                    <option>3</option>
                                    <option>4</option>
                                </select>
                            </div>
                            <div class="col-md-3 col-6">
                                <select class="form-control">
                                    <option>select sports</option>
                                    <option>1</option>
                                    <option>2</option>
                                    <option>3</option>
                                    <option>4</option>
                                </select>
                            </div>
                            <div class="col-md-3 col-6">
                                <button class="btn btn-gets"> just for today</button>
                            </div>
                            <div class="col-md-3 col-6">
                                <button class="btn btn-gets"> get history</button>
                            </div>
                        </div>
                </div> -->

                <div class="row">
                    <div class="col-12">
                        <h2 *ngIf="!isModal">Unsettled Bets</h2>
                        <div class="table-responsive">
                            <table class="table mb-0 table-bordered">
                                <thead>
                                    <tr>
                                        <th>bet id</th>
                                        <th>event</th>
                                        <th>market type</th>
                                        <th>selection</th>
                                        <th>type</th>
                                        <th>odds req.</th>
                                        <th>stake</th>
                                        <th>place time</th>
                                        <th>macthed time</th>
                                    </tr>
                                </thead>
                                <tbody *ngIf="data && data?.orders?.data?.length > 0">
                                    <tr [ngClass]="{'back' : item.bet_type == 1, 'lay': item.bet_type != 1, 'text-dlt' : (item?.status == 2 || item?.status == 3)}"
                                        *ngFor="let item of data?.orders?.data;let i=index;trackBy:trackByIndex;">
                                        <td>{{item?.id}}</td>
                                        <td>{{item?.event_name}}</td>
                                        <td>{{item?.market_type_id}}</td>
                                        <!-- <td>{{item?.runner_name}}</td> -->
                                        <td>{{(item.selection_name != null) ? item.selection_name : item?.market_name}}
                                        </td>
                                        <td>{{item.bet_type == 1 ? 'Back' : 'Lay'}}</td>
                                        <td>{{item?.average_rate_matched}}</td>
                                        <td>{{item?.stake_matched}}</td>
                                        <td>{{item?.requested_at_format | date: 'dd/MM/YYYY hh:mm:ss a'}}</td>
                                        <td>{{item?.matched_at_format | date: 'dd/MM/YYYY hh:mm:ss a'}}</td>
                                    </tr>
                                </tbody>

                                <tbody *ngIf="data && data.orders?.length == 0">
                                    <td colspan="8" class="noData"> {{env.noDataMsg}}</td>
                                </tbody>

                                <tbody *ngIf="!data">
                                    <tr>
                                        <td colspan="8">
                                            <app-loader class="no-overlay"></app-loader>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <!-- pagination -->
                            <div class="pagination" *ngIf="data && !isModal">
                                <nav class="Pager1" aria-label="pagination example">
                                    <ul class="pagination pagination-circle justify-content-center">
                                        <li class="page-item" [ngClass]="link.active == true ? 'active' : 'disabled'"
                                            *ngFor="let link of data?.orders?.links;trackBy:trackByIndex">
                                            <a class="page-link" href="javascript:void(0)" (click)="changePage(link)"
                                                [innerHTML]="link.label"></a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                            <!-- pagination -->

                            <button *ngIf="data && data?.orders?.next_page_url != null && isModal" type="button"
                                (click)="changePage(data?.orders?.next_page_url)">Load More</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>